import { Component } from '@angular/core';

@Component({
  selector: 'app-contrato-auri',
  templateUrl: './contrato-auri.component.html',
  styleUrls: ['./contrato-auri.component.scss']
})
export class ContratoAuriComponent {
  readonly contractText = `CONTRATO DE ADHESIÓN PARA LA ADQUISICIÓN DE BIENES Y PRESTACIÓN DE SERVICIOS,
QUE CELEBRAN POR UNA PARTE “AURI GRADUACIONES” REPRESENTADA POR EL C.
GABRIEL GONZÁLEZ GÓMEZ, A QUIEN EN LOS SUCESIVOS SE LE DENOMINARA “EL
PROVEEDOR” Y POR LA OTRA ÉL C._NOMBRE DEL ALUMNO _ , A QUIEN EN LO SUCESIVO
SE LE DENOMINARA “EL CONTRATANTE”, AL TENOR DE LAS SIGUIENTES:
DECLARACIONES
I.- DECLARA “EL PROVEEDOR”
A). - El C. Gabriel González Gómez, mexicano, mayor de edad, con Registro Federal de
Contribuyentes GOGG840219CR07;
B). - Que su domicilio fiscal se encuentra ubicado en calle Mariano Matamoros no.113,
Col. Centro, Pachuca de Soto, Hidalgo, C.P. 42000, con número telefónico 771-716-87-41,
con correo electrónico auri.graduaciones@gmail.com.
C). - Que “AURI GRADUACIONES” es un establecimiento dedicada a prestar servicios
especializados para graduaciones, contando con toda la capacidad, personal,
infraestructura, servicios, experiencia y recursos necesarios para dar cabal cumplimiento a
las obligaciones generadas en el presente contrato y de acuerdo a cada servicio
contratado;
II.- DECLARA EL “EL CONTRATANTE”
A). -Llamarse como ha quedado plasmado en el proemio de este contrato, con domicilio
en._REGISTRO_ y el cual señala como domicilio convencional para todos los efectos
legales del presente Contrato.
B). -Que tiene plena capacidad legal para la celebración del presente contrato, acto
jurídico y que no existe impedimento legal alguno, manifestando expresamente obligarse
en los términos y condiciones del mismo, por lo que, es su voluntad adquirir los servicios
que ofrece “EL PROVEEDOR”;
C). -Que acepta las condiciones que estipula el presente contrato de adhesión;
D). - Que ha recibido personalmente la información por parte de “EL PROVEEDOR” y que
acepta los TÉRMINOS Y CONDICIONES a los que se sujetará su contratación de acuerdo las
especificaciones establecidas en el presupuesto de los bienes y servicios elegidos;
D E F I N I C I O N E S
A). - “EL PROVEEDOR”, es la persona física que ofrece los bienes y prestación de servicios y
que se denomina: “AURI GRADUACIONES”;
B). - “EL CONTRATANTE”, es la Persona física o moral, que contrata los Servicios del
proveedor relativos a la adquisición de bienes y prestación de servicios;


C). - CONTRATO DE ADHESIÓN, es el Acto Jurídico, por el cual, ambas partes se obligan en
los términos y condiciones en que se encuentra estipulado el presente Instrumento Legal.
D). - PAQUETES DE GRADUACIÓN, conjunto de bienes y servicios que son convenidos
entre el vendedor y el comprador para un fin específico y un precio determinado, el cual
podrá constar de fiesta, viaje, cuadros, anillos y fotografía, las combinaciones de los
servicios contratados se denominan de la siguiente forma, dependiendo de su alcance
• Paquete 3 X 3
• Paquete 2 X 2
• Paquete de Individual
E). - PROMOCIONES GRUPALES, condiciones específicas que aplicaran cuando el 100 % de
los contratantes elijan un determinado servicio, en el entendido de que estas aplican solo
cuando es el total de ellos y de acuerdo a lo manifestado en cada hoja de servicio;
F). - COMITÉ Y REPRESENTANTES, serán hasta de 1 a 4 integrantes elegidos por el grupo,
que lo representarán cuando se trate de servicios conjuntos y quienes podrán decidir en
su nombre sobre temas relativos a características y condiciones para los paquetes de
fiesta, viaje, cuadros, anillos y fotografía, así como información general necesaria para
procesar sus paquetes;
D E C L A R A N A M B A S P A R T E S
A). - Que reconocen la NATURALEZA JURÍDICA del presente Contrato;
B). - Que en este acto se reconocen expresamente la personalidad con que se ostentan
para todos los efectos legales a que haya lugar y manifiestan que, por medio del presente
instrumento legal se SUJETAN de manera LIBRE y RESPONSABLE, en los términos y las
condiciones a lo estipulado en el mismo, siendo su LIBRE VOLUNTAD someterse al
contenido de las siguientes:
C L A U S U L A S
PRIMERA. - CONSENTIMIENTO DE LAS PARTES, las Partes de común acuerdo manifiestan
su voluntad para celebrar el presente contrato cuya naturaleza jurídica es la compraventa
de paquete de graduación; por lo que “EL PROVEEDOR”, se obliga a vender el paquete de
graduación conforme a las especificaciones establecidas en el presupuesto y el
“CONTRATANTE”, se obliga a pagar como contraprestación un precio cierto y
determinado;
SEGUNDA. - EL OBJETO del presente Contrato es la adquisición del paquete de graduación
o en su caso de productos o servicios individualizados cuyas características y precio se
detallan en el presupuesto que forma parte del presente convenio, proporcionando al
“CONTRATANTE” la asesoría relacionada con los SERVICIOS ELEGIDOS, contando el
“PROVEEDOR” con los siguientes:


A).- Fiesta de graduación;
B).- Viaje de graduación;
C).- Venta de cuadros y anillos;
D).- Toma de fotografías;
TERCERA. –DESCRIPCIÓN DE SERVICIOS, PRODUCTOS, COSTOS Y FORMA DE PAGO, a
continuación, se describirán cada uno de los productos y servicios ofrecidos y que podrán
ser elegidos en paquete o de forma individual o la combinación de varios, según los
intereses y necesidades del “CONTRATANTE”
FIESTA DE GRADUACIÓN, descripción del servicio y condiciones:
A). - “EL PROVEEDOR” gestionará y solicitará los servicios que se especificarán en la lista
adjunta, denominado hoja de control de evento, relativo de este contrato por cuenta de
“EL CONTRATANTE”, de acuerdo a la disponibilidad de los mismos, fungiendo como
intermediario entre éste y las personas encargadas de proporcionarlos directamente,
consistiendo en la prestación de servicios para la organización de un evento social, para el
número de personas definidas, en el lugar elegido y con las condiciones del anexo
respectivo;
B). - El evento social se llevará a cabo en la fecha definida en el anexo respectivo y con la
duración ahí especificada, dentro de la duración del evento no se cuenta el tiempo
necesario que “El PROVEEDOR” requiera para la organización del mismo que será minimo
de 1 mes o 30 días naturales con una duracion de 7 hrs. o lo que la hoja de anexo indique.
C). - “El PROVEEDOR” podrá cobrar una cantidad adicional, debidamente prevista en el
presupuesto, en el caso de que el evento prolongue su duración y/o el número de
invitados exceda del estipulado quedando con un costo que se definirá en el anexo
respectivo, por hora o fracción extra de ocupación y uso del inmueble, y el costo por
persona extra según lo estipulado en el anexo relativo a este apartado, reservándose en
todo momento la posibilidad de negar el servicio de no haberse pedido con la antelación
mínima acordada previo al evento;Así mismo el aumento de los costos por persona
posterior a la fecha máxima de venta regular que incrementrá dia con día sin obligación de
venta posterior por parte del prestador de servicios.
D). - El costo total que “El CONTRATANTE” debe solventar por la prestación del servicio en
el estipulado en la lista adjunta, la cual deberá cubrir por anticipo por la cantidad de
$10,000.- de manera grupal y no importando si el número de asistentes al evento es
inferior al acordado (250 personas invitadas como mínimo), debiendo ser cubierto en
moneda nacional y en la forma definida del anexo de que se trata, a la firma del presente
Contrato, por concepto de anticipo, el restante en las fechas señaladas previo el día de la
celebración del evento; Una vez iniciado este Contrato, “EL CONTRATANTE” se
compromete a cubrir la cantidad acordada un mes antes de celebrar la FIESTA DE
GRADUACIÓN y en tal circunstancia de que “EL CONTRATANTE” no haya cubierto la


cantidad se cobrará $10.- por día extra o lo que el proveedor considere por cambio de
tarifa; Debido a las variaciones de los precios de mercado los precios mencionados podrán
variar. “EL PROVEEDOR” expedirá el comprobante respectivo con la siguiente información:
nombre, razón social, fecha e importe del anticipo, nombre y firma de la persona
debidamente autorizada que recibe el anticipo y el sello del establecimiento, el nombre
del “EL CONTRATANTE”, la fecha, hora y tipo de evento; Los pagos de este servicio se
consideran únicamente el efectivo en moneda nacional.
E). - A efecto de tener seguridad en cuanto al número de asistentes al evento social, “EL
CONTRATANTE” y “EL PROVEEDOR” establecen como procedimiento de control y
verificación, el siguiente:
Ambas partes designarán, cada uno, a una persona de su confianza a efecto de que sólo
ingresen al lugar personas autorizadas por “EL CONTRATANTE” para lo cual, podrán
pactar el uso de un boleto o contraseña, éste, se responsabiliza del excedente de personas
que con su autorización expresa hayan ingresado al evento;
F). - “EL CONTRATANTE” cuenta con un plazo de cinco días naturales posteriores a la firma
del presente contrato para cancelar la operación sin responsabilidad alguna de su parte,
en cuyo caso “EL PROVEEDOR” se obliga a reintegrar las cantidades que el consumidor le
haya entregado, con la salvedad de el equivalente a los gastos administrativos generados,
monto señalado en el anexo respectivo, lo anterior no será aplicable si la fecha de la
prestación del servicio es posterior a los días estipulados consistentes en 30 días
naturales, pues ya se habrán ocupado los recursos en pagar los servicios que garantizan la
fecha del evento;
G). - “EL PROVEEDOR” designará, de entre su personal, a una persona que será quien
durante la celebración del evento trate con el representante del consumidor o con él
mismo, los asuntos relacionados con la prestación del servicio, y se obliga a que su
personal atienda con esmero y cortesía a los asistentes al evento.
H). - En su caso el consumidor se obliga a cumplir con las disposiciones reglamentarias que
rijan el inmueble y a procurar que los asistentes al evento observen la misma conducta.
Para tal efecto el prestador del servicio deberá entregar al consumidor una copia del
reglamento respectivo o bien fijar en un lugar visible sus disposiciones; Si los bienes
destinados a la prestación del servicio sufrieren un menoscabo por culpa o negligencia
debidamente comprobada del consumidor o de sus invitados, éste se obliga a cubrir los
gastos de reparación de los mismos, o en su caso, indemnizar a el prestador del servicio;
I). - Las partes podrán acordar que el consumidor contrate libremente servicios
específicos relacionados con el evento social con otros prestadores de servicios por así
convenir a sus intereses, por lo que en caso de actualizarse dicho supuesto el consumidor
exime de toda responsabilidad a el prestador del servicio en lo que respecta a dichos
servicios en específico.


J). - En caso de que el prestador del servicio se encuentre imposibilitado para prestar el
servicio por caso fortuito o fuerza mayor, como incendio, temblor u otros acontecimientos
de la naturaleza o hechos del hombre ajenos a la voluntad del prestador del servicio, no se
incurrirá en incumplimiento, por lo que no habrá pena convencional en dichos supuestos;
Las fiestas tendrán una duración de 7 hrs, por lo cual si el “CONTRATANTE” excede este
tiempo “EL PROVEEDOR” estará en pleno derecho de cobrar una penalización de acuerdo
a las horas extras del servicio que se hayan brindado.
Si “EL CONTRATANTE” llegase a cancelar el evento no se hará devolución de ningún tipo, y
se tendrá que pagar una compensación a “EL PROVEEDOR” por la falta de uso de “NO
SHOW”.
K).- En caso de contingencias sanitarias por covid u cualquier otro, Deberá justificarse por
medio del semáforo epidemiológico y las condiciones que dicten las autoridades sanitarias
del municipio, estado y nacional, teniendo en caso de impedimento 6 meses posteriores
para realizarse con los ajustes de tarifas al día de la nueva fecha.
L).- Todos los asistentes deberán presentar su contraseña para poder ingresar, no
teniendo oportunidad de ingreso posterior a la cena sin costo, de igual manera, los
asistentes menores de edad pagaran boleto de ingreso posterior al año de edad con
precio de boleto por niño, con el costo en la hoja anexa del servicio.
M).- Los platos y alimentos se preparan de manera higiénica y adecuada sin tener en
cuenta condiciones de alergias a alimentos, las personas con algún requerimiento
alimenticio deberán notificarlo por escrito con antelación de 15 días y no se garantiza por
las condiciones de cocina el libre contacto con agentes alérgicos en los alimentos.
VIAJE, descripción del servicio y condiciones:
A). - “EL PROVEEDOR” gestionará y solicitará los servicios que se especificarán en el anexo
relativo de este contrato, ANEXO 2, denominado hoja de control de viaje, por cuenta de
“EL CONTRATANTE”, de acuerdo a la disponibilidad de los mismos, a contratarlos
fungiendo como intermediario entre éste y las personas encargadas de proporcionarlos
directamente como transportistas, hoteles, restaurantes, arrendadoras de automóviles,
servicios terrestres, guías de turistas, y/o cualquier otro servicio a fin con el turismo, ya
sea en el país o en el extranjero, el precio del servicio, será el que se especifica detallado
en el anexo relativo, de este contrato; cuando se trate de viajes en el extranjero, se
deberán presentar los precios en moneda extranjera y en pesos, citando el tipo de cambio
en que están calculados éstos últimos, mencionando que el costo de ese servicio resulta
de la conversión a moneda nacional al momento en que se efectúe el pago, sirviendo este
tipo de cambio para todos los efectos consiguientes, reembolsos incluidos;
“EL PROVEEDOR” se reserva el derecho de contratar por cuenta de “EL CONTRATANTE”,
los servicios a que se refiere este contrato precisamente en las calidades o categorías
contratadas, en cuanto a hoteles, transportes y arrendadoras de autos se refiere, salvo


que expresamente se convenga que estos serán prestados invariablemente por un
proveedor determinado. En caso de modificación del prestador directo del servicio por
otro de calidad equivalente, si “EL CONTRATANTE” hace uso del servicio, se entenderá que
consintió con dicha modificación y no procederá reembolso alguno, aceptando que la
intervención de “EL PROVEEDOR” es exclusivamente con carácter de intermediario entre
los prestadores directos de los servicios solicitados;
B). - Se hace del conocimiento de “EL CONTRATANTE” que si por causa de fuerza mayor o
caso fortuito, como, huelgas, fallas técnicas, actos de terrorismo, fenómenos climáticos o
hechos de la naturaleza que acontezcan antes o durante el desarrollo de los servicios que
impidan, demoren o de cualquier modo obstaculicen que los prestadores de los servicios
contratados no pudieran proporcionarlos parcial o totalmente. “EL PROVEEDOR” solo
gestionará por cuenta de “EL CONTRATANTE” el reembolso que proceda, quedando
relevada de cualquier responsabilidad o compromiso, de igual manera quedará relevado
de responsabilidades por daños, heridas, accidentes, retrasos, irregularidades, pérdidas o
daños de objetos personales que sobrevengan durante la ejecución de los servicios que
pudiera ocurrirle a “EL CONTRATANTE” por no ser la persona directamente encargada de
prestar los servicios correspondientes y por ser solo intermediaria entre éstas y él, sin
embargo, auxiliará en todo momento en caso de algún inconveniente que pudiera tener
en su viaje, así como, coadyuvará para que el prestador final le reembolse lo pagado, si así
fuera el caso; reservándose el derecho de retener un 10% del total de la cantidad pagada
por la reservación como gasto administrativo;
C). - “EL CONTRATANTE” se compromete a respetar los reglamentos, reglas, horarios o
condiciones establecidas por cada uno de los prestadores de servicios contratados por
intermediación de “EL PROVEEDOR”, haciéndole del conocimiento lo anterior y en
consecuencia declina y se deslinda de cualquier responsabilidad que pudiera derivar por
su incumplimiento o negligencia, pudiendo el “EL PROVEEDOR”, en cualquier momento y
derivado del incumplimiento a las disposiciones mencionadas, cancelar la continuidad del
servicio en aras de la protección e integridad de los contratantes;
D). - “EL CONTRATANTE” deberá por medios propios proveerse de identificaciones
oficiales expedidas por las instituciones nacionales y los pasaportes o documentos de
migración requeridos por las autoridades de los Estados Unidos Mexicanos y de los países
de destino o de tránsito, tales como visas, permisos sanitarios, vacunas y otros,
atendiendo a la legislación vigente en cada país, “EL PROVEEDOR” no será responsable por
los inconvenientes, que pudiera sufrir por carecer de la documentación necesaria para
desplazarse en este u en otros países y previamente señalada; de igual forma
“EL CONTRATANTE” deberá contar con un seguro de gastos médicos, propio y en su caso
el proveedor le gestionará a su solicitud uno, quien decida viajar sin el seguro respectivo,
deberá firmar la exoneración relativa contenida en el anexo respectivo “EL PROVEEDOR”
no será responsable por los inconvenientes, tales como daños, lesiones físicas o mortales
que pudiera sufrir “EL CONTRATANTE”, al ponerse en una situación de riesgo mortal al


hacer caso omiso a las recomendaciones de cada lugar, uso de instalaciones, conductas
solicitadas de acuerdo a los sitios visitados y en general a cualquier situación imputable al
mismo;
E). - “EL PROVEEDOR” se reserva el derecho de modificar el orden de los servicios
indicados en el presente contrato, para un mejor desarrollo de los mismos o por las causas
que así lo justifiquen, respetando en todo momento la cantidad y calidad de los servicios
que se hayan contratado y de acuerdo al itinerario de viaje entregado y definido en el
anexo respectivo, a “EL CONTRATANTE” el cual consiste, de forma enunciativa, más no
limitativa, pasajes aéreos, hoteles, paquetes, arrendamiento de automóviles, con su
anuencia, sea cual fuese la causa, misma que deberá ser
comprobada; el“PROVEEDOR”, está obligado a actualizar las tarifas en forma constante,
en casos extremos, existe la posibilidad de que haya cambios en estas sin previo aviso, por
contingencias o causas de fuerza mayor, en estos casos, se harán revisiones periódicas y
en caso de que haya diferencias de tarifas entre el precio pagado por la reservación y el
precio requerido para usar el servicio, sin tener “EL PROVEEDOR” responsabilidad por
reclamaciones o inconvenientes derivados de esa situación;
F). - En cada reservación derivada del viaje, ya sea para transporte aéreo, terrestre o de
estancia hotelera, se requiere de un depósito el cual se reflejará al iniciar sesión en
www.sandboxmb2.com/app y que determinará “EL PROVEEDOR”, especificando el día,
lugar y forma de pago por persona, para garantizar los servicios inherentes solicitados por
el “EL CONTRATANTE”, los que una vez confirmados y de acuerdo a su plan de pago
deberán ser pagados totalmente a “EL PROVEEDOR” expidiendo este el número de
reservaciones o constancias relativas, documento que al momento de su impresión,
deberán contener los datos de identificación del prestador de servicios directo.
G). - Cuando haya una cancelación imputable a “EL CONTRATANTE”, queda obligado a
cubrir el porcentaje definido en el anexo respectivo, del valor del servicio adquirido, por
costos administrativos, más los relativos que reclame el prestador de servicios directo
afectado por la cancelación. Si la responsabilidad o causa de cancelación es imputable al
prestador de servicios directo “EL PROVEEDOR” deberá auxiliar y gestionar el apoyo al “EL
CONTRATANTE” para buscar que se solucione la contingencia y/o emergencia
consiguiendo los traslados correspondientes a su lugar de origen y desde luego, coadyuvar
para reclamar los reembolsos e indemnizaciones que correspondan conforme a la ley,
mediando únicamente en dicha tramitación. En el caso de que el prestador final de los
servicios demuestre la responsabilidad de “EL PROVEEDOR”, éste debe realizar los pagos
que correspondan conforme a la Ley;
H). - Para el caso de rescindir la solicitud de estos servicios relativos al viaje, existirá una
pena convencional, ya sea por el incumplimiento de las obligaciones plasmadas en el
presente contrato por cualquiera de las partes, por lo que deberán cubrir las cantidades
plasmadas como penalizaciones en el anexo respectivo, debiendo ser antes de los 30 días


a la fecha del viaje, independientemente de lo anterior deberán apegarse a lo
manifestado en el inciso anterior;
I). - “EL PROVEEDOR” otorgará PROMOCIONES GRUPALES, que “EL CONTRATANTE” podrá
tener cuando se reúnan los siguientes requisitos: haber cubierto sus pagos al 100 % y en
las fechas pactadas, así mismo el que sus demás compañeros en su carácter de
“CONTRATANTES” hayan cubierto sus respectivos paquetes de igual forma al 100 %, y que
todos lo hayan solicitado;
J). - CANCELACIONES Y CAMBIOS. Las partes convienen que las cancelaciones deberán ser
por escrito y “EL CONTRATANTE” dará contestación, relativa a las penalizaciones y fechas
especificadas en el anexo relativo, no se permiten cambios de fechas, rutas, ni servicios; se
admiten únicamente cambios de personas hasta 30 días antes de la fecha del servicio, con
un cargo establecido de 20% en el anexo respectivo; “EL CONTRATANTE” deberá cubrir los
pagos parciales correspondientes con una tolerancia de 24 horas posteriores a la fecha
estipulada, de lo contrario aplicará un cargo del 10% extra del total del viaje por retraso.
“EL PROVEEDOR” se reserva el derecho de revender en supuesto caso los espacios
retrasados.
NOTA: en el caso de viajes y fiestas no se hará ningún tipo de reembolso por el servicio
cancelado.
Si por motivo ajeno a la empresa el grupo cancela más del 60% total del viaje la empresa
tendrá la responsabilidad de integrarlo al grupo próximo más cercano teniendo como
plazo hasta 1 año posterior al evento.
K). - “EL CONTRATANTE” deberá liquidar al 100% el pago del paquete al menos 20 días
previos a la fecha de servicios contratados, de no ser así se aplicará un cargo extra del 20%
del total del costo. Teniendo un plazo máximo de 3 días naturales posteriores para hacer
el pago. De lo contrario quedará cancelado el servicio sin derecho a reembolso.
El horario de entrada es desde las 15:00 horas y el horario de salida es a las 12:00 horas.
*Puede variar de acuerdo a las políticas internas de cada país, cadena hotelera o
propiedad en la cual se reserve, por lo que hace al equipaje, en servicio terrestre, este es
responsabilidad única de los pasajeros, con derecho a transportar una maleta por cada
uno de ellos, el exceso de equipaje será transportado por cuenta y cargo de los pasajeros.
El “CONTRATANTE” se encuentra obligado a realizar sus pagos conforme al calendario ya
establecido, y en no más a 8 (ocho) pagos por los tres servicios.
L). - CONVENIO ADICIONALES. “El PROVEEDOR” queda relevado de cualquier
responsabilidad derivada de convenios adicionales que se hayan celebrado entre “EL
CONTRATANTE” y los prestadores directos de los servicios, como son hoteles, transportes
y arrendadores de autos, etc.
CUADROS, ANILLOS Y FOTOGRAFÍAS, descripción del servicio y condiciones:


A). - Los CUADROS En cualquier paquete, se entenderá como la adquisición de cuadros
con fotografías y agradecimientos ya sea diplomas, dípticos, trípticos o placas
personalizadas; la información para la elaboración de los mismos deberá ser
proporcionada dentro de los 5 días siguientes a la firma del presente contrato, en caso de
no proporcionar las características específicas, se designará el modelo genérico
tratándose de marcos;
B). - Los ANILLOS podrán elegirse en los siguientes metales: Oro, Plata o diverso metal y en
el kilataje acordado, en este caso en específico se ofrece la elaboración del troquel de
forma gratuita si por cada 5 contratantes eligen un modelo del catálogo, en caso de ser
menos de 5 se tendrá la opción de realizar el pago de la personalización que generará un
costo extra de $490.- por cada anillo en un modelo del catálogo de 3-4 gr; en caso de
elegir un modelo del catálogo de 5-6 gr en anillos de plata generará un costo de $100.-
adicional al costo de la personalización; para el caso de los anillos de oro 10K es un costo
de $2,500.- adicional al costo de la personalización, en caso contrario si el modelo es único
deberá cubrirse el troquelado, el cual tiene un costo de $950.- por cada nuevo diseño. La
selección y medida del anillo se llevará a cabo dentro de la sesión fotográfica por el
personal de la empresa y firmada de aprobación por parte del cliente, en caso de no asistir
o no elegir se optará por el modelo mayormente elegido o genérico; en caso de duda, se
verificará de acuerdo a la lista solicitada y en caso de ajuste por error del cliente tendrá un
costo extra por ajuste por la cantidad de $200.- en plata y $900 en oro.-
C). - La LOCACIÓN será ofertada por “EL PROVEEDOR” durante el inicio a la firma de este
Contrato y será “EL CONTRATANTE” quien elija la locación de su preferencia. En el
supuesto de que “EL CONTRATANTE” elija una locación para la sesión de fotografía
distinta a las ofertadas debe cumplir con 2 (dos) condiciones: a) ser un lugar al aire libre,
b) tener la autorización del uso de las instalaciones mediante un oficio firmado y sellado
por la institución o dependencia que regule dichas instalaciones, por tal motivo, “EL
CONTRATANTE” se compromete a realizar todas las gestiones necesarias para la sesión
fotográfica, asumiendo todos los gastos de ingreso y operación que resulte de la misma.
Los gastos de viáticos y/o gasolina serán cubiertos por “EL PROVEEDOR” en un radio no
mayor a 20 km de la Ciudad de Pachuca, Hidalgo, entendiendo que si fuera una distancia
mayor, “EL PROVEEDOR” podrá realizar un cobro extra por gastos de transportación,
horario extendido y viáticos. Dicho documento deberá ser enviado a “EL PROVEEDOR”
como máximo 10 días hábiles antes de la toma de fotografía para su adecuado
planteamiento de logística; en caso de no recibir los documentos de aprobación en
tiempo y forma, la empresa tomará la decisión de elegir la locación que se ajuste a su
agenda, en caso de negativa por “EL CONTRATANTE”; “EL PROVEEDOR” se deslinda de
toda responsabilidad y se reservará el derecho de acudir a dicha toma fotográfica.
D). - Para la SESIÓN TEMÁTICA, “EL CONTRATANTE” tendrá la oportunidad de elegir entre
a) globos) ó b) “polvos holi”; los cuales tendrán que ser confirmados con anticipación de
15 días hábiles con el Asesor asignado ó mediante la aplicación oficial de comunicación


entre ambas Partes. La sesión temática se celebrará únicamente durante la sesión de
fotografía agendada y será en el horario que establezca “EL PROVEEDOR”. En caso de que
“EL CONTRATANTE” opte por la sesión temática de “Polvos holi”, “EL CONTRATANTE”
queda exento de toda responsabilidad por la ropa perjudicada y/o alergias que puedan
causar en la piel.
E). - La FOTOGRAFÍA, será tomada y editada según las condiciones elegidas y estipuladas
en la orden de fotografía, el tiempo para la sesión fotográfica será de dos horas y
comenzará a la hora acordada con los Graduados que hayan llegado. La empresa trabajará
bajo el esquema protocolario antes mencionado por lo que “EL CONTRATANTE” que
llegue con demora solo tendrá oportunidad de tomarse las fotografías que marque el
protocolo y los fotógrafos de la empresa se reservan el derecho de volver a comenzar las
fotografía. La sesión de fotografía tiene duración de 2 horas por lo que se sugiere
presentarse de ropa cómoda en el lugar elegido por “EL CONTRATANTE”, para la toma, o
en el estudio que “EL PROVEEDOR” proporcionara; Para “EL CONTRATANTE que haya
pagado una foto familiar enmarcada se capturará bajo las siguientes indicaciones:
1) La foto familiar enmarcada tendrá un precio de $950.- y “EL CONTRATANTE” deberá
comunicarle al fotógrafo que se realizó el pago una foto familiar enmarcada. Dicha
fotografía se tomará al finalizar la sesión y no se tomará ninguna fotografía familiar antes,
ni durante la sesión fotográfica para no interrumpir con el protocolo que se tiene
establecido. “El PROVEEDOR” se reservará el derecho de cancelar la sesión en caso de no
acatar las indicaciones mencionadas.
F). - “EL PROVEEDOR” llegará con anticipación de media hora a la locación agendada y “EL
CONTRATANTE” deberá asistir puntualmente, en caso de solicitar cualquier cambio de
fecha, locación o cualquier otro tema relacionado con la foto esta deberá presentarse por
escrito mínimo 15 días previos a la toma de foto, teniendo la resolución por escrito en
acuerdo con ambas partes.
G). - Bajo el esquema de protección a la salud se solicita respetar y acatar las indicaciones
que “EL PROVEEDOR” proporcione, por lo que el día de la toma de foto, “EL
CONTRATANTE” podrá tener un máximo de 2 personas como acompañantes si el espacio
solicitado lo permite y deberán acatar las indicaciones del personal de fotografía en todo
momento, así como seguir las normas de seguridad, protección e higiene que proporcione
la Secretaría de Salud; en caso de no ser así, “EL PROVEEDOR” podrá reservarse el
derecho de admisión a la toma de fotografía. Es también necesario cubrir el primer pago
de acuerdo al método de pago elegido por “EL CONTRATANTE” para tener ingreso a la
toma de fotografía.
H), Las medidas que tomará el “EL PROVEEDOR” para evitar cualquier incidente será al
inicio del presente Contrato, será la comunicación entre “EL PROVEEDOR” y “EL
CONTRATANTE” para conocer si alguno de “LOS CONTRATANTES” pudiera presentar
alguna enfermedad o alergia durante la sesión de fotografía para tomar las medidas


necesarias para controlar dicha situación. En caso de emergencia “EL PROVEEDOR”
tomará la siguientes determinaciones:
I) En caso de desastre natural, ambas partes deberán conservar la calma trasladarse a un
lugar seguro hasta que “EL PROVEEDOR” ó autoridades determinen que las circunstancias
son aptas para continuar con la sesión de fotografía.
II) En caso de enfermedad congénita “EL PROVEEDOR” realizará el protocolo de Activación
del Sistema de Emergencia (PAS) que consiste en los siguiente a) Proteger, b) Avisar, c)
Socorrer (Durante la espera del personal de emergencia. “EL PROVEEDOR” dispondrá de
un botiquín de Primeros Auxilios y mantendrá al accidentado en posición neutra (boca
arriba con los brazos y piernas extendidos). “EL PROVEEDOR” proporcionará la atención
no profesional sanitario y se deslinda de la total responsabilidad por el accidente causado,
dejando al personal socorrista realizar la labor pertinente).
H). - “EL CONTRATANTE”, para un control de los servicios antes mencionados,
proporcionará la información de acuerdo a la hoja de datos y orden de servicio individual,
anexo 3;
I).- En caso de eventualidades técnicas imputables a la empresa, se re agendará nueva
sesión coordinando fecha con el representante del grupo, de igual forma cuando las
condiciones climáticas no lo permitan; en cualquiera de los casos mencionados en este
apartado, la recalendarización no generará un costo extra.
J).- Sesiones especiales, estas serán con cargo extra de acuerdo al pedido del “EL
CONTRATANTE”; Las sesiones foráneas no generarán un costo extra en un radio no mayor
a 20 km, de ser un lugar que exceda este kilometraje se generará un costo de transporte el
cual deberá ser cubierto por “EL CONTRATANTE”. El lugar deberá ser al aire libre y contar
con la autorización y los permisos necesarios para hacer el uso de las instalaciones, todo
esto siendo revisado y tramitado por “EL CONTRATANTE”.
K). - Una vez realizada la toma fotográfica, las exposiciones obtenidas, serán revisadas y
aprobadas por “EL CONTRATANTE” la cual será definitiva para las impresiones a ocupar en
los cuadros solicitados, “EL CONTRATANTE” se obliga a proporcionar mediante formato
anexo todos los datos necesarios para elaborar los paquetes de graduación, tales como
listas, medidas iniciales, modelos acordados, materiales, etc. Dicha información deberá ser
proporcionada en los 15 días hábiles siguientes a la firma del presente contrato, cualquier
demora imputable al adquirente se reflejará en la postergación de la fecha de entrega.
H).- Al elegir escudos o logotipos de su instituciones oficiales educativas, estos serán
basados en los originales proporcionados en la hoja de control, así mismo se compromete
a proporcionar las autorizaciones necesarias para su uso y reproducción, manifestando
desde ahora “EL PROVEEDOR” que las únicas variaciones serán las propias de las
reducciones a escala de acuerdo al tamaño de los modelos solicitados, quedando la
responsabilidad de su uso al “EL CONTRATANTE” deslindando de cualquier controversia
y/o situación legal que se pudiera derivar del uso de los mismos;
L). - La entrega de los paquetes será en el lugar, día y hora acordado por las partes y el
cual será definido en la hoja de datos anexa al presente contrato, con la salvedad de
otorgar hasta 3 días hábiles posteriores a dicha fecha para que “EL CONTRATANTE” pueda
recogerlo; de no ser así, se deberá cubrir una cuota de $500.- por almacenaje teniendo


máximo 20 días naturales para liquidar antes de que el paquete sea cancelado y proceda a
reciclaje. En caso de que “EL CONTRATANTE” no pueda asistir el día de la entrega deberá
designar a una persona para que acuda a recoger el paquete dando aviso previo a “EL
PROVEEDOR” y asistiendo con los recibos correspondientes y el último pago. Todos los
pagos deberán efectuarse en efectivo. En cuyo caso el paquete sea cancelado “El
ADQUIRENTE” deberá contratar el servicio nuevamente con un contrato nuevo y con los
paquetes que estén vigentes en ese momento.
M). - Las causas de cancelación del presente servicio, serán las siguientes:
I. - Cancelación a solicitud del “EL CONTRATANTE”, deberá ser por escrito dentro de los 5
días hábiles siguientes a la firma del presente contrato, devolviendo “EL PROVEEDOR” el
importe de los anticipos cubiertos por este concepto (validar penalizaciones);
II.- Cancelación por inasistencia a la toma de fotografía en la fecha estipulada; “EL
PROVEEDOR” proporcionará una carta de cancelación en donde el “EL CONTRATANTE”
aceptará la cancelación del servicio y no adeudo alguno aceptando los cargos por
concepto de Anticipos; (“EL PROVEEDOR” (el importe de los anticipos cubiertos por este
concepto en su caso);)
III.- Cancelación por incumplimiento y/o retraso en más de dos pagos en los tiempos
establecidos, ya que el “PROVEEDOR” depende de dichas aportaciones para los materiales
y elaboración de los mismos, sin obligación de devolver los anticipos, ya que se han
destinado a gastos de materias primas y costos administrativos;
IV.- Cancelación por no recoger el paquete en las fechas programadas de acuerdo a la hoja
de servicio, otorgando un periodo de gracia de 3 días hábiles, sin posibilidad de devolución
de ningún importe y sin responsabilidad de “EL PROVEEDOR”;
La cancelación de este producto, podrá ser independiente a los diversos productos o
servicios que “EL CONTRATANTE” haya contratado con “EL PROVEEDOR” manteniendo
cualquier otro que haya solicitado ya sea fiesta y/o viaje;
El “PROVEEDOR” no se encuentra obligado a reagendar una nueva toma de fotografía por
la inasistencia por parte de “ EL CONTRATANTE”, por lo cual se le exonera de cualquier
responsabilidad de este tipo y que pudiese reflejarse en las fotografías.
Si “EL PROVEEDOR” llegara a perder el material por causas técnicas, éste se encuentra
obligado a reagendar una nueva cita para realizar la sesión fotográfica lo más pronto
posible contando con el apoyo de “EL CONTRATANTE”.
En caso de factores externos (cambios de clima no favorables, terremotos, etc) el “EL
PROVEEDOR” tendrá todas las facultades de realizar una nueva cita para la toma de
fotografía, por lo cual el “EL CONTRATANTE” acepta abstenerse de cualquier tipo de
represalias que pudiera tomar en contra de la empresa o su representante.
N). - El “PROVEEDOR” otorgará PROMOCIONES GRUPALES, que “EL CONTRATANTE” podrá
tener cuando se reúnan los siguientes requisitos: haber cubierto sus pagos al 100 % y en
las fechas pactadas, así mismo el que sus demás compañeros en su carácter de
“CONTRATANTES” hayan cubierto sus respectivos paquetes de igual forma al 100 %, y que


todos lo hayan solicitado; CONFORMACIÓN DE GRUPO CONTRATANTE.- El grupo quedará
conformado de acuerdo a la cantidad de “CONTRATANTES” que presenten en término de
su solicitud individual; Las solicitudes de adhesión al grupo que se efectúen con
posterioridad a dicho plazo, quedarán sujetas a disponibilidad de plazas, rigiendo en este
caso la tarifa y formas de pago vigentes a la fecha de aceptación.
Las promociones que se lleguen a dar son totalmente intransferibles y solo serán válidas
hasta el tiempo establecido por “EL PROVEEDOR”, por lo cual no podrá haber prórroga de
cualquier tipo.
O). - La vía de comunicación entre “EL PROVEEDOR” y “EL CONTRATANTE” será mediante
la aplicación de mensajería instantánea más efectiva para “EL PROVEEDOR” en donde
compartirá las indicaciones e instrucciones de acceso a la página
www.sandboxmb2.com/app para el registro del presente Contrato, solución de dudas,
aclaraciones, recordatorios, elección de fondo para los cuadros de graduación, validación
de anillos, notificaciones para la entrega y cualquier otro tipo de asuntos que “EL
PROVEEDOR” solicite. “EL CONTRATANTE” se compromete a estar de inicio a fin durante la
vigencia de este Contrato, de cualquier otra manera “EL PROVEEDOR” se deslinda de
cualquier error que pueda presentarse en relación al pedido solicitado y las correcciones
quedarán a cargo por “EL CONTRATANTE”. En caso de motivo extraordinario “EL
CONTRATANTE” llegara a salir del grupo, deberá integrarse de manera inmediata y
comunicarle a “EL PROVEEDOR” para que pueda integrarse nuevamente y pedir las
últimas noticias durante su ausencia. En caso de que “EL CONTRATANTE” haya salido de la
aplicación oficial de comunicación por su propio medio deberá notificarle a “EL
CONTRATANTE” para poder proceder a la cancelación del Contrato.
CUARTA. - EL PRECIO TOTAL, se expresa al acceder a la página
www.sandboxmb2.com/app, en donde se detallarán los alcances y características
elegidas, así como los precios desglosados de cada producto o servicio contratado, el cual
será cubierto en el establecimiento del ”EL PROVEEDOR” de la siguiente manera;
I. Se deberá cubrir el monto de $200.- por concepto de anticipo y el resto en un máximo
de 8 días posterior a la fecha de firma, siempre y cuando el 100% del grupo liquide sus
paquetes; en caso de existir retraso tendrán máximo 15 días para liquidar, teniendo que
reagendar la entrega dependiendo de la disponibilidad de “EL PROVEEDOR”.
II. El precio total del paquete de graduación será expresado de manera individual al
acceder a la página www.sandboxmb2.com/app, el cual podrá ser cubierto en moneda
nacional, cheque, tarjeta de crédito y depósito bancario. sin menoscabo de poderlo hacer
en moneda extranjera al tipo de cambio publicado en el Diario Oficial de la Federación al
día en que el pago se efectúe y en el establecimiento de “EL PROVEEDOR”. La empresa
ofrece a “EL CONTRATANTE” elegir una de las dos (dos) modalidades de anticipo para la
contratación del servicio y se elige de la siguiente forma: a) La cantidad de $200.00
(Doscientos pesos 00/100 M.N.) de manera individual a la firma del presente Contrato por
concepto de anticipo en los primeros 8 días hábiles de haber recibido las indicaciones por
parte de “EL PROVEEDOR” en el medio de comunicación oficial asignado por “EL
PROVEEDOR”. El anticipo es individual e intransferible y deberá ser efectuado en el


establecimiento de “EL PROVEEDOR”, mediante depósito bancario o transferencia a la
cuenta que les proporcionen los asesores de venta de la empresa en el medio oficial de
comunicación, “EL CONTRATANTE” debe envíar el comprobante de pago legiblemente al
número de pagos que proporciona “EL CONTRATANTE”, adjuntando el comprobante de
pago con los siguientes datos: Nombre completo de “EL CONTRATANTE”, escuela, y
carrera. b) Se realiza un anticipo grupal, el cuál consiste de 1 a 15 contratantes $1000.- y
de 16 contratantes en adelante $2000.- El anticipo debe ser efectuado en el
establecimiento de “EL PROVEEDOR”, mediante depósito bancario o transferencia a la
cuenta que proporciona “EL PROVEEDOR” en el medio oficial de comunicación. “EL
CONTRATANTE” debe envíar el comprobante de pago de manera legible al número de
pagos que proporciona “EL CONTRATANTE”, adjuntando el comprobante de pago con los
siguientes datos: Nombre completo de “EL CONTRATANTE”, escuela, y carrera. “EL
CONTRATANTE” debe envíar el comprobante de pago legiblemente al número de pagos
que proporciona “EL CONTRATANTE”, adjuntando el comprobante de pago con los
siguientes datos: Nombre completo del o las personas que envían el depósito y la cantidad
de cada uno, escuela, y carrera.
La cantidad restante se realizará en pagos establecidos de manera grupal, los cuales
tienen dos modalidades:
A) 50% al momento de la toma de fotografía y 50% el día de la entrega, con un lapso de
entrega de dos meses y medio a tres; “LOS CONTRATANTES” que no cubran el pago
acordado, se les notificará mediante el grupo oficial de WhatsApp la fecha límite como
oportunidad de pagar como plazo máximo e ingresará a Producción como pedido
desfasado y “EL PROVEEDOR” se comunicará de manera privada para el seguimiento de su
paquete de graduación. En caso de persistir el incumplimiento de pago, el pedido entrará
en estatus de cancelación sin derecho a reembolso.
B) 30% en la toma de fotografía, 30% un depósito intermedio al mes posterior de la toma
de foto y 40% a la entrega, con un lapso de tres meses y medio de la toma a la entrega. La
selección del calendario es grupal y aplica como promoción. Por tal motivo el
incumplimiento individual de los contratantes cambiará la fecha de entrega.
Se considera la posibilidad de cancelar el pedido grupal si el 10% o más del total del grupo
no realizará sus pagos en tiempo y forma. Condicionando de esta manera las entregas,
precios y promociones del grupo en general. En caso de que el 90% del grupo pague
conforme a lo acordado se ingresará a producción y los demás quedarán cancelados sin
derecho a reactivación ni reembolso alguno.
III. El precio total del paquete de graduación será expresado al iniciar sesión en la página
de www.sandboxmb2.com/app el cual puede ser cubierto en efectivo o transferencia
bancaria, cheque, tarjeta de crédito y depósito bancario. En caso de que “EL
CONTRATANTE” realice el pago con cheque y no se cubra el pago por causas imputables al
librador, “EL PROVEEDOR” se reserva el derecho de realizar el cobro adicional del 20%
(veinte por ciento) del valor del documento, por concepto de daños y perjuicios, en caso


de que el cheque sea devuelto por causas imputables al librador. Por el pago del anticipo,
“EL PROVEEDOR” deberá expedir el comprobante respectivo, el que contendrá la
siguiente información: nombre, razón social o denominación social, fecha e importe del
anticipo, nombre y firma de la persona debidamente autorizada que recibe el anticipo el
sello del establecimiento, el nombre de “EL CONTRATANTE” y la fecha de entrega del
anticipo. Independientemente de la entrega del comprobante de pago del anticipo, El
vendedor deberá entregar a “EL CONTRATANTE” la factura que ampare el pago del precio
total del paquete de graduación, documento que deberá cumplir con los requisitos que
señalen las leyes mexicanas vigentes en materia fiscal. El vendedor se obliga a respetar el
precio convenido de acuerdo al presupuesto,
III. “EL PROVEEDOR” se obliga a respetar el precio convenido de acuerdo al presupuesto,
así como también se obliga a respetar el precio convenido fijado en este Contrato y su
presupuesto que forma parte íntegra del mismo, aún y cuando haya cambios de precios
en el mercado internacional de metales preciosos y no podrá hacer cobro alguno que no
se encuentre estipulado en el presente Contrato
QUINTA. - ENTREGA DEL PAQUETE DE GRADUACIÓN .- “EL CONTRATANTE” se obliga a
liquidar y recoger el paquete de graduación objeto del presente Contrato, en la fecha
estipulada en el presupuesto y en el domicilio de “EL PROVEEDOR”, otorgándole un plazo
de 3 (tres) días hábiles, sin cargo adicional al precio señalado en el presente Contrato,
transcurrido este plazo “EL PROVEEDOR” podrá cobrar a “EL CONTRATANTE” por concepto
de almacenaje la cantidad de $500.- teniendo un plazo máximo de almacenaje de 15 días.
SEXTA. - OBLIGACIONES DE LAS PARTES: Obligaciones de “EL PROVEEDOR”: a) Cumplir con
lo establecido en el presente Contrato. b) Entregar el paquete de graduación conforme a
lo requerido por “EL CONTRATANTE”. c) No hacer cobró hacer ningún cobro extraordinario
ajeno al señalado en el presente Contrato. d) No condicional a El comprador la venta del
paquete de graduación con la venta y/o adquisición de otro bien no solicitado por el
comprador. e) Entregar el paquete de graduación en la fecha establecida en el presente
Contrato. Obligaciones de “EL CONTRATANTE”: a) Cumplir con lo establecido en este
Contrato. b) Proporcionar a “EL PROVEEDOR” la información requerida para la elaboración
del paquete de graduación. c) Hacer el pago correspondiente en los términos pactados en
el presente Contrato. d) Recoger el paquete de graduación en la fecha estipulada.
SÉPTIMA. - CAUSALES DE RESCISIÓN. - Son causas de rescisión del presente Contrato las
siguientes:
a).- Incumplimiento de lo estipulado en el presente Contrato por alguna de las Partes.
b). - Si “EL PROVEEDOR” no entrega el paquete de graduación con las especificaciones de
kilataje, color, modelo, calidad y características especificadas en el presupuesto en la
fecha señalada y en los términos pactados en el presente Contrato;
c).- Por falta de pago de “EL CONTRATANTE” en los términos previstos en el presente
Contrato. En los casos previstos anteriormente, quien motive la rescisión de forma
comprobada, pagará a la otra parte como pena convencional el 10% (diez por ciento) del
precio total pactado en el presente Contrato. En caso de que la rescisión haya sido


ocasionada por parte de El vendedor éste deberá además devolver todas las cantidades
que El comprador le haya entregado, en un plazo no mayor a 5 (cinco) días naturales.
OCTAVA. - CANCELACIÓN DEL CONTRATO. - “EL CONTRATANTE” podrá cancelar el
presente Contrato, sin responsabilidad y penalización alguna de su parte, dentro de los 5
(cinco) días naturales posteriores a la firma del mismo, puntualizando que la cancelación
podrá ser general o individual de acuerdo a los servicios contratados, con los detalles
descritos en cada uno de los servicios y teniendo como referencia el anexo respectivo que
contiene los datos de cada servicio, forma de pago y penalizaciones, en cuyo caso “EL
PROVEEDOR” se obliga a devolver las cantidades que le hubieren entregado en un plazo
igual al indicado en la presente Cláusula, con la salvedad de que los servicios de fiesta y
viaje, se apegan a lo estipulado en la descripción correspondiente como penalización y
gastos administrativos;
NOVENA. - GARANTÍA. - “EL PROVEEDOR” a la fecha de entrega y liquidación del paquete
de graduación entregará un certificado de garantía que no podrá ser inferior a sesenta
días naturales contados a partir de la entrega del paquete de graduación y servicios
contratados, no amparando dicha garantía los daños que hayan sufrido el paquete de
graduación por causas imputables a “EL CONTRATANTE” o bien, si se le hacen
reparaciones en talleres o agencias distintas a las de “El PROVEEDOR”. El cumplimiento de
la garantía señalada en la presente Cláusula, deberá de solicitarse en el domicilio de EL
PROVEEDOR.
DÉCIMA. - AVISO DE PRIVACIDAD. - Previo a la firma del presente Contrato y en
cumplimiento a lo dispuesto en la Ley Federal de Protección de Datos Personales en
Posesión de los Particulares, “EL PROVEEDOR” hizo del conocimiento a “EL
CONTRATANTE” del aviso de privacidad, así como del procedimiento para ejercer los
derechos de acceso, rectificación, cancelación y oposición al tratamiento de sus datos
personales;
DÉCIMA SEGUNDA. - JURISDICCIÓN Y MARCO LEGAL.- La Procuraduría Federal del
Consumidor es competente en la vía administrativa para resolver cualquier controversia
que se suscite sobre la interpretación o cumplimiento del presente Contrato. Sin perjuicio
de lo anterior, Las partes se someten a la jurisdicción de los Tribunales competentes de
esta ciudad, renunciando expresamente a cualquier otra jurisdicción que pudiera
corresponderles, por razón de sus domicilios presentes o futuros o por cualquier otra
razón; leído para el conocimiento de Ambas Partes; enteradas de su Contenido y Alcance,
se suscribe por Duplicado para Constancia, entregándose un juego a cada parte, para los
efectos legales a que haya lugar, en la Ciudad de Pachuca, Hidalgo a los 20 días del mes de
marzo del año 2019;
DECIMA TERCERA. - Ambas partes de común acuerdo respecto a las obligaciones y
derechos que mutuamente les corresponde en sus respectivas calidades de
CONTRATANTE y PROVEEDOR, convienen en agregar circunstancias que no hayan sido


motivo de cláusula expresa en el presente contrato, y que se podrá añadir en un anexo al
presente, previo convenio entre las partes.
DADAS LAS CONDICIONES BAJO LAS QUE SE FIRMA EL PRESENTE CONTRATO ES DE
SUPREMA IMPORTANCIA ESPECIFICAR QUE La firma del contacto de grupo, avala y acepta
las condiciones bajo las que el grupo ha contratado los servicios antes mencionados y
especificados en los anexos correspondientes de los servicios. Sin importar la naturaleza
de las condiciones se han plasmada en el anexo y aplican para el total del grupo
contratante sin ser omisión en no acudir a o conectarse a las reuniones de zoom o
cualquier otro medio virtual en las que se hubiera compartido la información de las
condiciones de contratación siendo permeable a familiares y cualquier otra persona que
se viera involucrada en la contratación del presente contrato.
FUNDAMENTO LEGAL Y COMPETENCIA JURISDICCIONAL, el presente contrato se funda en
lo que disponen los artículos 1, 8, 14, 16 Constitucionales, de igual forma en lo que
disponen los 1776, 1777, 1778, 1779, 1782, 1787, 1816, 1817, 2044, 2062, 2230, 2231,
2237, 2251, 2298, del Código Civil; 1, 3, 27, 29, 44, 47, 78, 79, 80, 81, 82, 84, 85, 86, 89, 90,
94, 95, 127, 154 fracción II y IV, 272, 276, 279, 282, 286, 407, 409, 415, 420 del Código de
Procedimientos Civiles vigente en el Estado; 46 y 47 de la Ley Orgánica del Poder Judicial
del Estado de Hidalgo, la Norma Oficial Mexicana, PROY-NOM-136-SCFI-1998, Prácticas
comerciales-Requisitos de información para la comercialización de paquetes de
graduación; NOM-111-SCFI-1995 Prácticas comerciales-Elementos informativos y
requisitos para la contratación de servicios para eventos sociales; NOM-126-SCFI-1997
Prácticas comerciales-Requisitos mínimos de información para la prestación de servicios
fotográficos, de laboratorio fotográfico y de grabación en video; los artículos 39 fracción
V, 40 fracción III, 47 fracción I de la Ley Federal sobre Metrología y Normalización, 33 del
Reglamento de la Ley Federal sobre Metrología y Normalización.
Leído que fue por ambas partes este documento ante los testigos que también firman e
impuestos de su contenido y sabedores de las obligaciones que contraen, lo firman por
duplicado en_______________________________________________, a los _______ días
del mes de ____________________________ del año _____________.
PUNTOS IMPORTANTES DE TU CONTRATO QUE DEBES CONOCER
Horario de tomas de foto.
Las tomas de foto se realizarán en el horario establecido en la hoja de control con una
duración de 2 hrs. Iniciando a la hora señalada en el pedido y no a la hora que el grupo se
reúna completo. Te solicitamos acudir puntualmente y de preferencia con veinte minutos
de anticipación; de esta manera tendrás mayor cantidad de fotos para recordar en tu
sesión. En caso de solicitar cualquier cambio de fecha, locación o cualquier otro tema
relacionado con la foto esta deberá ser por escrito y firmada por todos los integrantes del
grupo mínimo 15 días previos a la toma de foto, surgiendo efecto a partir de la
contestación por escrito y teniendo en común acuerdo la nueva fecha. Existen factores


externos que pueden demorar la llegada de nuestro equipo al punto de encuentro, el cual
será notificado en el grupo de WhatsApp. Auri Graduaciones se reserva el derecho de
cancelación por omisión de este punto
Selección de anillo.
Para cumplir con la promoción de elegir modelo de anillo en paquetes, se escogerá de
manera grupal un modelo para hombres y un modelo para mujeres con un mínimo de
pedido de 5 personas por género, en caso menor, será solo un modelo para ambos con un
mínimo en conjunto de 5 pedidos. El modelo será de 3 a 4 gr. como se indica nuestra
promoción de paquetes grupal. De no ser así la empresa elegirá el modelo genérico sin
costo o podrás elegir la personalización de grabado láser por $490.- o $990.- por troquel,
por cada anillo. La selección y toma de medida del anillo se llevará a cabo dentro de la
sesión fotográfica. En caso de no asistir o no elegir se considerará el modelo mayormente
elegido o genérico. La medida será tomada por personal de la empresa y firmada de
aprobación por parte del cliente, en caso de duda, se verificará de acuerdo a la lista
solicitada y en caso de ajuste por error del cliente tendrá un costo extra por ajuste.
Factores climáticos.
Las condiciones climatológicas son un factor no controlable (tormenta, huracán). En caso
de ocurrir algún fenómeno meteorológico extremo que impida la realización de la sesión
esta será recalendarizada a la fecha próxima en común acuerdo entre el grupo y la
empresa sin tener costo alguno. Cualquier otro motivo de cambio o cancelación podrá
generar costos extras.
Calendario de pagos.
Existen 2 opciones de pago y se elige una de manera grupal:
50-50%: Cubrir el 50% en la toma de foto, 50% en la entrega, con un lapso de dos meses y
medio a tres. Los Graduados que no cubrieron el pago acordado, se les dará la
oportunidad de pagar 10 días posteriores como plazo máximo y entrará a producción
como desfasado. En caso de incumplimiento con el pago, su pedido pasa a un estatus de
cancelación sin derecho a reactivación ni reembolso alguno.
30-30-40%: 30% en la toma de foto, 30% un depósito intermedio al mes posterior de la
toma de foto y 40% a la entrega, con un lapso de tres meses y medio de la toma a la
entrega. La selección del calendario es grupal y aplica como promoción. Por tal motivo el
incumplimiento individual de los contratantes cambiará la fecha de entrega.
Considerando la posibilidad de cancelar el pedido grupal si el 10% o más del total del
grupo no realizará sus pagos en tiempo y forma. Condicionando de esta manera las
entregas, precios y promociones del grupo en general. En caso de que el 90% del grupo
pague conforme a lo acordado se ingresará a producción y los demás quedarán
cancelados sin derecho a reactivación ni reembolso alguno.


Importante:
Auri Graduaciones pondrá fecha límite en el grupo de WhatsApp para cubrir la cantidad
acordada para mandar a producción el pedido. En caso de no abonar dicha cantidad, el
contrato pasará a estatus de Destiempo y el Graduado tendrá que reactivar el contrato
por la cantidad de $500.- más la cantidad de adeudo del Paquete de Graduación.
Existen 2 posibilidades de anticipo para la contratación del servicio y se elige por grupo:
Se realiza un anticipo individual de $200.- que son contemplados en el total de tu compra.
El anticipo debe ser enviado mediante depósito o transferencia a la cuenta que te
proporcionó tu Asesor de Graduación y enviarlo al número 7714146033 anexando el
comprobante de pago con los siguiente datos:
Nombre completo del Graduado
Escuela
Carrera
Grupo
Se realiza un anticipo grupal, el cuál consiste de 1 a 15 Graduados un anticipo de $1000.- y
de 16 Graduados en adelante un anticipo de $2000.- El anticipo debe ser enviado
mediante depósito o transferencia a la cuenta que te proporcionó tu Asesor de
Graduación y enviarlo al número 7714146033 anexando el comprobante de pago los
siguiente datos:
Nombre completo de la o las personas que envían el depósito y la cantidad de cada uno.
Escuela
Carrera
Grupo
Comunicación entre Auri Graduaciones y Graduados
La vía de comunicación entre las dos partes en el grupo de WhatsApp creado por Auri
Graduaciones; en el grupo se toman en cuenta los siguientes temas:
Indicaciones de cómo registrarse y cómo elegir Paquete.
Solución de dudas.
Aclaraciones
Recordatorios.
Elección de fondo para los Cuadros de Graduación
Es muy importante que todos los Graduados estén integrados en el grupo oficial de
WhatsApp desde el primer contacto hasta la culminación del contrato. En caso de que
algún Graduado por motivo extraordinario se llegara a salir del grupo, deberá integrarse
de manera inmediata y comunicarse con Auri Graduaciones para atender dicha situación.
Todos los Graduados sin excepción a alguno que llegue a ausentarse en el grupo y
perderse de las indicaciones de auri Graduaciones, perderá el total privilegio de tomar
decisiones sobre los asuntos relacionados a los Paquetes de Graduación. Auri


Graduaciones comparte este documento al grupo oficial de WhatsApp para que todos los
Graduados tengan conocimiento del proceso y no se pierdan de las indicaciones.
Permisos en lugares externos
Las condicionantes para la toma de foto durante el año 2022 son dos: ser un lugar al aire
libre y tener la autorización del uso de las instalaciones mediante un oficio firmado y
sellado 10 días antes para dicho evento, por tal motivo los Graduados se comprometen a
realizar todas las gestiones necesarias para la realización de la sesión fotográfica,
asumiendo los gastos de ingreso y operación que resulten de la misma. Los gastos de
viáticos y/o gasolina serán cubiertos por la empresa en un radio no mayor a 20 km de la
ciudad de Pachuca, entendiendo que si fuera una distancia mayor, la empresa puede
hacer cobro extra por gastos de transportación, horario extendido y viáticos. En caso de
no recibir los documentos de aprobación en tiempo y forma, la empresa se deslinda de
toda responsabilidad y se reserva el derecho de acudir a dicha toma.
Número máximo de acompañantes (Padres y Familiares).
Bajo el esquema de protección a la salud que impera en el mundo, derivado de la
pandemia por Covid-19, les solicitamos acatar las indicaciones que indique la autoridad en
el momento de la toma de foto y entrega de paquetes. Acudiendo preferentemente hasta
2 acompañantes por Graduado para la toma de foto si el espacio solicitado lo permite. En
dado caso de que el Graduado haya pagado una foto familiar enmarcada con precio de
$1200.- deberá comunicarle al fotógrafo que se realizó el pago por dicha fotografía. Las
fotografías familiares se toman al finalizar la sesión y no se tomará ninguna fotografía
familiar antes, ni durante la sesión fotográfica para no interrumpir con el protocolo que se
tiene establecido. Auri Graduaciones se reserva el derecho de cancelar la sesión en caso
de no acatar las indicaciones mencionadas.
Protocolo de toma de fotografía
La sesión de fotografía comenzará a la hora acordada y se comenzará la sesión con los
Graduados que hayan llegado. Los Graduados que lleguen con demora solo tendrán
oportunidad de tomarse las fotografía que marque el protocolo y los fotógrafos de Auri
Graduaciones se reservan el derecho de volver a comenzar las fotografía. Recuerda que la
sesión tiene duración de 2 horas por lo que te recomendamos ir de ropa cómoda.
Sesiones Temáticas
Los Graduados tendrán la oportunidad de elegir “Globos” o “Polvos Holi” para su sesión
temática; sin embargo, tendrán que ser confirmadas por los Graduados con anticipación
de 15 días hábiles.
En caso de elegir en la sesión temática “Polvos Holi”, se aclara que mancha la ropa, por lo
que Auri Graduaciones queda exento de la responsabilidad por la ropa perjudicada y/o
alergias que puedan causar en la piel.
Acciones Protección a la Salud


Con el afán de promover la salud y proteger a nuestros graduados, te solicitamos seguir
este protocolo de salud para la toma de foto y entrega de paquetes.
Si presentas síntomas de posible contagio por Covid 19 (tos, fiebre, diarrea, escurrimiento
nasal, dolor de cabeza o de garganta, malestar general) te solicitamos NO Acudir. Quédate
en casa y en caso de ser necesario podremos realizar una toma posterior para ti. Deberás
portar cubre boca en todo momento ya que en caso de no contar con él no se prestará el
servicio. Te solicitamos mantener la sana distancia, utilizar gel antibacterial y evitar tocar
superficies. Todas las acciones por mínimas que parezcan son indispensables para la
promoción de la salud y evitar contagios. Auri Graduaciones se reserva el derecho de
cancelar la sesión en caso de no acatar las indicaciones mencionadas y se deslinda por los
riesgos derivados de la naturaleza de los servicios contratados.
Protocolo para la prevención y atención en caso de emergencia
Existen tres tipos de atención en caso de emergencia:
En caso de desastre natural: Auri Graduaciones al realizar eventos en espacios abiertos
pero no queda exento de accidentes provocados por la naturaleza (sismos, terremotos) si
no se actúa de manera correcta. En caso de suceder, los Graduados deberán conservar la
calma y seguir las indicaciones de la empresa para desplazarse a un lugar seguro y esperar
a recibir nuevas instrucciones para continuar con la sesión de fotografía. Recuerda no
correr, no gritar, no empujar.
En caso de accidente ocasionados por el entorno (hemorragias, atragantamiento,
fracturas, picaduras, mordeduras, intoxicaciones, lesiones por el calor o frío, lesiones
oculares, entre otros).
En caso de enfermedad (alteraciones de la conciencia, asma, lesiones por insolación, entre
otros): Al comenzar la vigencia de este contrato tu Asesor de Graduaciones se comunicará
vía WhatsApp preguntando si algún Graduado tiene alguna enfermedad de la cual
debemos estar enterados para tomar las medidas necesarias y prevenir accidentes el día
de la toma de fotografía. En caso de contar con Graduados susceptible a una enfermedad
el Asesor de Graduación se comunicará de manera privada y solicitará la información
necesaria como para conocer el proceso que se debe tomar; también solicitará
acompañantes el día de la toma de fotografía para el auxilio en caso de presentarse la
enfermedad durante la sesión de fotografía.
Para los 3 tipos de caso se realizará el protocolo de Activación del Sistema de Emergencia
(PAS) el cual consiste en lo siguiente:
Proteger: Se debe asegurar que tanto el accidentado como los demás estén fuera de
peligro.
Avisar: Ante una emergencia vital se alertará a los servicios de socorro sin demora al 911.
Se notificará el lugar exacto del accidente, el tipo de accidente y circunstancias del mismo,
el número de heridos y el estado aparente de la o las personas accidentadas; también se
notificará a los acompañantes del o los Graduados.


Socorrer: Durante la espera del personal de emergencia. Auri Graduaciones dispondrá de
un botiquín de Primeros Auxilios y mantendrá al accidentado en posición neutra (boca
arriba con los brazos y piernas extendidos). Auri Graduaciones proporcionará la atención
no profesional sanitario y se deslinda de la responsabilidad por el accidente causado,
dejando al personal socorrista realizar la labor pertinente.
Registro en el sistema.
El día de la toma de fotografía todos los Graduados deberán llegar registrados y con
paquete de Graduación seleccionado.
Se enlista a continuación el proceso de registro en el sistema:
Paso 1: Una vez que todos los Graduados estén agregados en el grupo de WhatsApp tu
Asesor de Graduación dará comienzo con las indicaciones para el correcto registro en el
sistema.
Paso 2: Tu Asesor de Graduación dará la bienvenida a todos los integrantes del grupo y
compartirá un video tutorial el cual explica el proceso de principio a fin sobre cómo
registrarse y lo importante de llenar cada campo con los datos correctos.
Paso 3: Después de haber visto el video tutorial, el asesor de Auri Graduaciones
compartirá el segundo link, el cuál corresponde al registro en el sistema donde deben
registrarse totalmente en mayúsculas.
Paso 4: Tu Asesor de Graduación compartirá el tercer link (https://sandboxmb2.com/app)
donde mediante un mensaje de texto obtendrán su contraseña.
Notas:
Al aceptar los Términos y Condiciones se aceptan todos los acuerdos realizados de manera
grupal e individual.
En caso de no recibir mensaje de texto con la contraseña, deben asegurarse de haber
escrito correctamente su número celular, que no haya espacios entre números, no poner
más de 10 números. En caso de continuar con dificultades en el registro deben ponerse
en contacto vía WhatsApp al número 7714478619 para agendar una llamada con un
Asesor de Graduación.
Selección de Paquete de Graduación.
Después del registro, el proceso continúa con la selección del Paquete de Graduación y
personalización:
Paso 1: Los Graduados seleccionan el paquete de su preferencia.


Paso 2: Seguidamente, ir a las pestañas de: “Placas”, “Marcos”, “Colores” para seleccionar
las opciones de tu agrado.
IMPORTANTE: No pulses “Solicitar Paquete” si no estás seguro de lo que has agregado,
pues una vez haciendo click ya no podrás hacer modificaciones a tu paquete.
Notas:
Se debe elegir Placa de acuerdo al paquete que se seleccionó; es decir, si tu paquete es
“Light” deberás elegir una Placa “Light” si es un Cuadro Macro Elite podrás elegir
cualquiera del catálogo. En caso de elegir una Placa Elite en un Cuadro Macro Light tiene
un costo adicional de $350.- y deberás seleccionar en la Pestaña Productos Adicionales el
producto “Cambio de Placa”.
En caso de elegir un Paquete que incluya “Diploma o Agradecimiento” vendrá por
predeterminado un Diploma; de ser el caso de querer elegir un Agradecimiento deberán
dirigirse a la pestaña de “Dedicatorias”, agregar a quién va dirigido y elegir un texto.
Únicamente se elegirán las especificaciones de Cuadro Macro y el Agradecimiento, los
demás artículos no se tienen que elegir manualmente (ya los incluye el Paquete),
solamente en caso de solicitar un Producto Adicional al Paquete seleccionado se tendrá
que seleccionar manualmente.
En caso de tener dificultades con la selección del Paquete de Graduación, deben ponerse
en contacto vía WhatsApp al número 7714478619 para agendar una llamada con un
Asesor de Graduación.
En caso de no registrarse no procederá la producción de tu pedido por falta de datos sin
derecho a reclamación por pagos realizados.
Pago el día de la toma de fotografía.
El día de toma de foto se deberá realizar el pago al inicio de la sesión en efectivo para
poder tener ingreso y poder participar de la sesión fotográfica. Este será únicamente en
efectivo y los pagos subsecuentes se realizarán de acuerdo a tu calendario grupal. Los
pagos efectuados por depósito o transferencia bancaria se deberán enviar vía WhatsApp
al número 7714146033. Anexando el comprobante de pago y los siguientes datos:
Nombre completo, Escuela, Carrera y Grupo. Al realizar la transferencia en el campo de
concepto deberás colocar tu nombre completo. Los pagos para viaje y fiesta son en
efectivo en la sucursal teniendo como opción de realizar transferencias bancarias por
causas de fuerza mayor.
Fecha de entrega.
Nuestro equipo de Producción se comunicará a través del grupo de WhatsApp para indicar
el día y la hora en la que deben asistir a nuestra sucursal ubicada en: C. PI.. de la
Independencia 111-C Centro, 42000 Pachuca de Soto, Hgo.
https://goo.gl/maps/QbVqw7H5qVgs1Kxh6. Las fechas de entrega no son aplazables ni
transferibles dado que la contingencia derivada por Covid 19 nos obliga a respetar las
normas operativas y de sana distancia te solicitamos acudir el día, hora y lugar


establecidos. En caso de no poder asistir en persona, cualquier familiar, conocido o
integrante del grupo podrá recibir tu paquete con los recibos de pago en físico o en foto
de manera legible.
El día de la entrega se realiza el pago pendiente. Este pago deberá ser en efectivo. En caso
de no presentarse el Graduado contará con 3 días posteriores a la entrega para recoger
sus piezas sin ningún costo extra. Posterior a esta fecha la empresa podrá cobrar $500.-
extra por almacenamiento por un máximo de 20 días hábiles. Posterior a esta fecha el
paquete será cancelado y reciclado sin posibilidad de reactivación o negociación alguna.
Forma de pago
Todos los pagos deberán ser en efectivo, en caso de tener un pago intermedio de 30%
será el único en depósito. Los cuales deberán ser enviados al número 7714146033 vía
WhatsApp. Los pagos se verán reflejados en un plazo de 5 días hábiles salvo buen cobro.
Importante:
Auri Graduaciones pondrá fecha límite en el grupo de WhatsApp para cubrir la cantidad
acordada para mandar a producción el pedido. En caso de no abonar dicha cantidad, el
contrato pasará a estatus de Destiempo y el Graduado tendrá que reactivar el contrato
por la cantidad de $500.- más la cantidad de adeudo del Paquete de Graduación.
Condiciones para la toma de foto
Son dos: toma directa o montaje. Para la realización de esta sesión fotográfica, los
Graduados de manera grupal elegirán un fondo para todo el grupo, pudiendo elegir entre
tomas directas o montajes. Ambas se realizarán en la misma sesión teniendo como opción
individual la elección de cualquiera de las dos tomas para la realización del marco
fotográfico, quedando de manera automática la otra toma como regalía de cortesía en
papel. La sesión temática es una promoción en regalo y las fotografías se entregarán de
manera digital mediante un Código QR a la entrega de los paquetes. Toda fotografía no
escrita en el contrato no podrá realizarse. Los estándares de tomas grupales montadas se
muestran de manera pública en nuestra oficina, quedando como estándar de calidad y
proporción de la toma solicitada. Existirá una sesión digital para la aprobación de dichas
fotos por medio de un comité, no habiendo posibilidad de cambios o cancelaciones una
vez haya sido aprobada.
La omisión o desconocimiento de cualquier dato es responsabilidad del Graduado, dado
que por la naturaleza de la realización, firma de contratos y acuerdos en grupo, es
responsabilidad del contratante solicitar a la empresa todos los datos requeridos antes de
la firma del contrato, entendiendo que a la firma del mismo, se aceptan todas las
condiciones bajo las cuales se realizó este acuerdo y del contrato.
Para todos los particulares te solicitamos leer tu contrato, ya que en él encontrarás las
condiciones que permean este pedido.


Firmamos el siguiente documento en conformidad y aceptando las condiciones aquí
descritas.
Gracias y muchas Felicidades Graduado!


`;

  imprimir(): void {
    window.print();
  }
}
